var _path, _path2, _path3, _path4, _path5, _path6, _path7, _path8, _path9, _path10, _path11, _path12, _path13;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgAnalytics(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 40,
    height: 41,
    viewBox: "0 0 40 41",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M35 5.56543H27.1739V6.96786H35V5.56543Z",
    fill: "#1A1F36"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M27.1739 8.60404H35V10.0065H27.1739V8.60404Z",
    fill: "#1A1F36"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M28.5968 11.6426H27.1739V13.0451H28.5968V11.6426Z",
    fill: "#1A1F36"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M30.3755 11.6426H31.7984V13.0451H30.3755V11.6426Z",
    fill: "#1A1F36"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M35 11.6426H33.5771V13.0451H35V11.6426Z",
    fill: "#1A1F36"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M13.1818 25.0826V33.9063H17.8063V29.4068H19.2292V33.9063H20.7708V25.0826H22.1937V33.9063H26.8775V29.4068H28.3004V33.9063H29.8419V25.0826H31.2648V33.9063H35V35.3087H5V33.9063H8.79447V29.4068H10.2174V33.9063H11.7589V25.0826H13.1818Z",
    fill: "#1A1F36"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    d: "M15.3886 17.2126C14.7348 17.7321 13.9383 18.084 13.0661 18.2022V20.2022C14.4935 20.0675 15.7913 19.4953 16.8198 18.6232L15.3886 17.2126Z",
    fill: "#7B3BE3"
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    d: "M17.6478 17.7865C18.601 16.6383 19.1728 15.1706 19.1728 13.5713C19.1728 11.9482 18.5839 10.4608 17.6052 9.30512L16.1715 10.7182C16.7894 11.5076 17.157 12.4971 17.157 13.5713C17.157 14.6216 16.8055 15.5911 16.2122 16.3716L17.6478 17.7865Z",
    fill: "#7B3BE3"
  })), _path9 || (_path9 = /*#__PURE__*/React.createElement("path", {
    d: "M15.336 9.88878L16.7688 8.47663C15.7486 7.62858 14.47 7.07281 13.0661 6.94033V8.94033C13.915 9.0554 14.6923 9.39189 15.336 9.88878Z",
    fill: "#7B3BE3"
  })), _path10 || (_path10 = /*#__PURE__*/React.createElement("path", {
    d: "M11.8803 8.92576V6.93018C8.6126 7.18171 5.99741 9.72367 5.68609 12.9285H7.71531C8.0092 10.8222 9.72682 9.16338 11.8803 8.92576Z",
    fill: "#7B3BE3"
  })), _path11 || (_path11 = /*#__PURE__*/React.createElement("path", {
    d: "M11.8803 18.2168C9.68714 17.9748 7.94606 16.2588 7.70052 14.0972H5.67578C5.93408 17.3569 8.57298 19.9578 11.8803 20.2124V18.2168Z",
    fill: "#7B3BE3"
  })), _path12 || (_path12 = /*#__PURE__*/React.createElement("path", {
    d: "M15.9119 13.5713C15.9119 15.4754 14.3457 17.0189 12.4138 17.0189C10.4819 17.0189 8.91581 15.4754 8.91581 13.5713C8.91581 11.6672 10.4819 10.1236 12.4138 10.1236C14.3457 10.1236 15.9119 11.6672 15.9119 13.5713Z",
    fill: "#7B3BE3"
  })), _path13 || (_path13 = /*#__PURE__*/React.createElement("path", {
    d: "M34.8292 15.6206L31.3269 19.0724L29.074 16.8519L24.4494 21.4098L22.3151 19.3062L19.2363 22.3406L18.3978 21.5142L22.3151 17.6534L24.4494 19.757L29.074 15.1991L31.3269 17.4197L33.9907 14.7942L34.8292 15.6206Z",
    fill: "#7B3BE3"
  })));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgAnalytics);
export default __webpack_public_path__ + "static/media/analytics.c8bd3436fea1afc374def61da1543a8c.svg";
export { ForwardRef as ReactComponent };